/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Account */
export interface Account {
  /** Username */
  username: string;
  /** Account Id */
  account_id: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Name */
  name?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /** Access Key Id */
  access_key_id: string;
  /** Access Key Secret */
  access_key_secret: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Master Account */
  master_account: boolean;
  /** Mfa Enabled */
  mfa_enabled?: boolean;
  /** Mfa Type */
  mfa_type?: string;
  /** Logo */
  logo?: string;
  /** Enforce Mfa */
  enforce_mfa?: boolean;
  /** Inactivity Lock */
  inactivity_lock?: boolean;
  /** Inactivity Days */
  inactivity_days?: number;
}

/** AccountCreate */
export interface AccountCreate {
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Subscriber */
  subscriber?: string;
  /** Token */
  token?: string;
}

/** AccountIdp */
export interface AccountIdp {
  /** Metalink */
  metalink: string;
  /** Entity Id */
  entity_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Account Id */
  account_id: string;
  /** Account Idp Id */
  account_idp_id: string;
  /** Idp Name */
  idp_name: string;
  /** Issuer */
  issuer: string;
  /** Sso Url */
  sso_url: string;
  /** Certificate */
  certificate: string;
}

/** AccountIdpCreate */
export interface AccountIdpCreate {
  /** Metalink */
  metalink: string;
  /** Entity Id */
  entity_id?: string;
}

/** AccountIdpUpdate */
export interface AccountIdpUpdate {
  /** Metalink */
  metalink: string;
  /** Entity Id */
  entity_id?: string;
}

/** AccountOps */
export interface AccountOps {
  /** Webhook Url */
  webhook_url: string;
  /** Email */
  email: string;
  /** Down Event Email */
  down_event_email?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Signature Key */
  signature_key: string;
}

/** AccountOpsSet */
export interface AccountOpsSet {
  /** Webhook Url */
  webhook_url: string;
  /** Email */
  email: string;
  /** Down Event Email */
  down_event_email?: string;
}

/** AccountUpdate */
export interface AccountUpdate {
  /** Username */
  username: string;
  /** Name */
  name?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /** Password */
  password?: string;
}

/**
 * AdditionalLanPort
 * One option for the LAN bridge "additional ports" picker.
 *
 * Every entry in the response is a port the controller will currently
 * accept; presence in the list = availability. Selected indicates whether
 * it's a current bridge member. The edit-cpe-network endpoint still takes
 * a flat list[str] of port names — input shape is just intent.
 *
 * A saved bridge member is always still in the allowed set: SFP/copper
 * layout is fixed at provisioning, and cpe_configure_secondary_wan refuses
 * to enable WAN1 while eth2 is bridged.
 */
export interface AdditionalLanPort {
  /** Name */
  name: string;
  /** Selected */
  selected: boolean;
}

/** AnalyzePcapResp */
export interface AnalyzePcapResp {
  /** Document Id */
  document_id: string;
  /** Filename */
  filename: string;
  /** Summary */
  summary: string;
}

/** ApiLog */
export interface ApiLog {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Account Id */
  account_id?: string;
  /** Account Username */
  account_username?: string;
  /** Iam User Id */
  iam_user_id?: string;
  /** Iam User Username */
  iam_user_username?: string;
  /** Url Path */
  url_path?: string;
  /** Query Parameters */
  query_parameters?: string;
  /** Request Body */
  request_body?: string;
}

/**
 * AppService
 * Additional properties to return via API
 */
export interface AppService {
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** Fqdn */
  fqdn?: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** App Service Name */
  app_service_name: string;
  /** App Service Id */
  app_service_id: string;
  /** Deployment */
  deployment: string;
  /** Policy */
  policy?: string;
  /**
   * Open Ai Private Link
   * @default false
   */
  open_ai_private_link?: boolean;
  /** Azure User Email */
  azure_user_email?: string;
  /** Primary Contact Id */
  primary_contact_id?: string;
  /** Secondary Contact Id */
  secondary_contact_id?: string;
  /** Size */
  size?: number;
  /** Health */
  health?: number;
}

/**
 * AppServiceCreate
 * Properties to receive via API on creation
 */
export interface AppServiceCreate {
  /** Fqdn */
  fqdn?: string;
  /** Location */
  location: string;
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Region */
  region?: string;
  /** Cloud Endpoint Service Name */
  cloud_endpoint_service_name?: string;
  /** Private Endpoint Ip Address */
  private_endpoint_ip_address?: string;
  /** Remote Vnet Resource Id */
  remote_vnet_resource_id?: string;
  /** Real Subnets */
  real_subnets?: string;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** App Service Name */
  app_service_name: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
  /**
   * Open Ai Private Link
   * @default false
   */
  open_ai_private_link?: boolean;
  /** Azure User Email */
  azure_user_email?: string;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /**
   * Address Translation Enabled
   * @default false
   */
  address_translation_enabled?: boolean;
  /** Virtual Subnet Pools */
  virtual_subnet_pools?: string;
}

/** AppServiceDetail */
export interface AppServiceDetail {
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** Fqdn */
  fqdn?: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** App Service Name */
  app_service_name: string;
  /** App Service Id */
  app_service_id: string;
  /** Deployment */
  deployment: string;
  /** Policy */
  policy?: string;
  /**
   * Open Ai Private Link
   * @default false
   */
  open_ai_private_link?: boolean;
  /** Azure User Email */
  azure_user_email?: string;
  /** Primary Contact Id */
  primary_contact_id?: string;
  /** Secondary Contact Id */
  secondary_contact_id?: string;
  /** Endpoints */
  endpoints: Ep[];
  /** User Agents */
  user_agents: UserAgent[];
  /** Region */
  region?: string;
  /** Local Vnet Resource Id */
  local_vnet_resource_id?: string;
  /** Remote Vnet Resource Id */
  remote_vnet_resource_id?: string;
  /**
   * Address Translation Enabled
   * @default false
   */
  address_translation_enabled?: boolean;
  /** Virtual Subnet Pools */
  virtual_subnet_pools?: string;
  /** Real Subnets */
  real_subnets?: string;
  /** Virtual Subnets */
  virtual_subnets?: string;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Local Ip */
  bgp_local_ip?: string;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** Size */
  size?: number;
  /** Health */
  health?: number;
  /** Primary Contact */
  primary_contact?: string;
  /** Secondary Contact */
  secondary_contact?: string;
}

/** AppServiceHosting */
export interface AppServiceHosting {
  /** Fqdn */
  fqdn?: string;
  /** Location */
  location: string;
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Region */
  region?: string;
  /** Cloud Endpoint Service Name */
  cloud_endpoint_service_name?: string;
  /** Private Endpoint Ip Address */
  private_endpoint_ip_address?: string;
  /** Remote Vnet Resource Id */
  remote_vnet_resource_id?: string;
  /** Real Subnets */
  real_subnets?: string;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** App Service Id */
  app_service_id: string;
}

/**
 * AppServiceUpdate
 * Properties to receive via API on update
 */
export interface AppServiceUpdate {
  /** App Service Id */
  app_service_id?: string;
  /** App Service Name */
  app_service_name?: string;
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** Fqdn */
  fqdn?: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
}

/** AssistantMessage */
export interface AssistantMessage {
  /** Role */
  role: 'assistant';
  /** Text */
  text: string;
}

/** BillingStribePaymentMethodCreate */
export interface BillingStribePaymentMethodCreate {
  /** Payment Method Type */
  payment_method_type: string;
  /** Card Number */
  card_number: string;
  /** Exp Month */
  exp_month: number;
  /** Exp Year */
  exp_year: number;
  /** Cvc */
  cvc: number;
  /** Name */
  name?: string;
  /** Email */
  email?: string;
  /** Phone */
  phone?: string;
  /** Street Addr 1 */
  street_addr_1?: string;
  /** Street Addr 2 */
  street_addr_2?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Postal Code */
  postal_code?: string;
  /** Country */
  country?: string;
}

/** BillingStripeCreateSubscription */
export interface BillingStripeCreateSubscription {
  /** Name */
  name: string;
  /** Email */
  email: string;
  /** Phone */
  phone?: string;
  /** Street Addr 1 */
  street_addr_1?: string;
  /** Street Addr 2 */
  street_addr_2?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Postal Code */
  postal_code?: string;
  /** Country */
  country?: string;
  /** Payment Method Id */
  payment_method_id: string;
}

/** Body_analyze_pcap_api_v1_analyze_pcap_post */
export interface BodyAnalyzePcapApiV1AnalyzePcapPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** Body_login_api_v1_token_post */
export interface BodyLoginApiV1TokenPost {
  /**
   * Grant Type
   * @pattern password
   */
  grant_type?: string;
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Otp */
  otp?: string;
  /** Subscriber */
  subscriber?: string;
  /** Account Id */
  account_id?: string;
  /**
   * Scope
   * @default ""
   */
  scope?: string;
  /** Client Id */
  client_id?: string;
  /** Client Secret */
  client_secret?: string;
}

/** Body_new_iam_user_setup_password_api_v1_new_iam_user_set_password_post */
export interface BodyNewIamUserSetupPasswordApiV1NewIamUserSetPasswordPost {
  /** Password */
  password: string;
  /** Iam User Token */
  iam_user_token: string;
}

/** Body_reset_password_api_v1_reset_password_post */
export interface BodyResetPasswordApiV1ResetPasswordPost {
  /** New Password */
  new_password: string;
  /** Access Token */
  access_token: string;
}

/** Body_set_cpe_denial_of_service_thresholds_api_v1_set_cpe_denial_of_service_thresholds_post */
export interface BodySetCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost {
  tcp_syn_flood_thresholds: DosThreshold;
  udp_thresholds: DosThreshold;
  icmp_thresholds: DosThreshold;
}

/** Body_user_agent_signin_api_v1_user_agent_signin_post */
export interface BodyUserAgentSigninApiV1UserAgentSigninPost {
  /** Email */
  email: string;
  /** Session Id */
  session_id: string;
}

/** CancelCaptureResp */
export interface CancelCaptureResp {
  /** Result */
  result: string;
}

/**
 * CellularCarrier
 * An enumeration.
 */
export enum CellularCarrier {
  Generic = 'Generic',
  ATT = 'AT&T',
  Verizon = 'Verizon',
  TMobile = 'T-Mobile',
}

/** CellularConfigRequest */
export interface CellularConfigRequest {
  /** Cpe Id */
  cpe_id: string;
  /**
   * Allow Data Failover
   * @default true
   */
  allow_data_failover?: boolean;
  /** Apn */
  apn?: string;
}

/** CellularConfigResponse */
export interface CellularConfigResponse {
  /** Allow Data Failover */
  allow_data_failover?: boolean;
  /** Apn */
  apn?: string;
}

/** CellularStatusResponse */
export interface CellularStatusResponse {
  /** Status */
  status?: string;
  /** Operator Name */
  operator_name?: string;
  /** Rat */
  rat?: string;
  /** Roaming */
  roaming?: boolean;
  /** Signal Quality Pct */
  signal_quality_pct?: number;
  /** Imei */
  imei?: string;
  /** Iccid */
  iccid?: string;
  /** Modem Model */
  modem_model?: string;
  /** Apn */
  apn?: string;
  /** Timestamp */
  timestamp?: string;
  /** Ip Address */
  ip_address?: string;
  /** Default Gateway */
  default_gateway?: string;
  /** Dns Servers */
  dns_servers?: string[];
}

/** CertificateDisableRequest */
export interface CertificateDisableRequest {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Group Name */
  service_node_group_name?: string;
}

/** CertificateUploadRequest */
export interface CertificateUploadRequest {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Group Name */
  service_node_group_name?: string;
  /** Certificate */
  certificate: string;
  /** Private Key */
  private_key: string;
  /** Ca Chain */
  ca_chain: string;
}

/** ConnectConsoleAccess */
export interface ConnectConsoleAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Hw Id Path */
  hw_id_path: string;
  /**
   * Console Mode
   * @default "usb"
   */
  console_mode?: string;
}

/** ConnectNetworkRemoteAccess */
export interface ConnectNetworkRemoteAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
  /**
   * Protocol
   * @default "ssh"
   */
  protocol?: string;
  /**
   * Ssh Username
   * @default ""
   */
  ssh_username?: string;
  /**
   * Target Domain
   * @default ""
   */
  target_domain?: string;
  /** Mac Addr */
  mac_addr: string;
}

/** ConnectRawSshAccess */
export interface ConnectRawSshAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
  /** Mac Addr */
  mac_addr: string;
}

/**
 * Contact
 * Additional properties to return via API
 */
export interface Contact {
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Email */
  email: string;
  /** Phone */
  phone?: string;
  /** Address */
  address?: string;
  /** Company Name */
  company_name?: string;
  /** Contact Type */
  contact_type?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Contact Id */
  contact_id: string;
  /** Account Id */
  account_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Entity Name */
  entity_name?: string;
}

/**
 * ContactCreate
 * Properties to receive via API on creation
 */
export interface ContactCreate {
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Email */
  email: string;
  /** Phone */
  phone?: string;
  /** Address */
  address?: string;
  /** Company Name */
  company_name?: string;
  /** Contact Type */
  contact_type?: string;
  /** Entity Name */
  entity_name?: string;
}

/** Correspondence */
export interface Correspondence {
  /** Ticket Id */
  ticket_id: string;
  /** Correspondence */
  correspondence?: string;
  /** Parent Correspondence Id */
  parent_correspondence_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Created By */
  created_by: string;
  /** Correspondence Id */
  correspondence_id: string;
}

/** CorrespondenceCreate */
export interface CorrespondenceCreate {
  /** Ticket Id */
  ticket_id: string;
  /** Correspondence */
  correspondence?: string;
  /** Parent Correspondence Id */
  parent_correspondence_id?: string;
}

/**
 * Cpe
 * Shared properties
 */
export interface Cpe {
  /** Cpe Name */
  cpe_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /**
   * Mode
   * @default "ROUTER"
   */
  mode?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Cpe Id */
  cpe_id: string;
  /** Netflow Enabled */
  netflow_enabled?: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled?: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled?: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** App Visibility Enabled */
  app_visibility_enabled?: boolean;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Entity Id */
  entity_id?: string;
  /** Test Status */
  test_status?: string;
  /**
   * Test Started At
   * @format date-time
   */
  test_started_at?: string;
  /** Ping Email Notification */
  ping_email_notification?: string;
  /** Ping Webhook Notification */
  ping_webhook_notification?: string;
  /** Ip Monitor Target */
  ip_monitor_target?: string;
  /**
   * Iperf Server
   * @default false
   */
  iperf_server?: boolean;
  /**
   * Perf Test Scheduled
   * @default false
   */
  perf_test_scheduled?: boolean;
  /** Perf Test Peer Ip */
  perf_test_peer_ip?: string;
  /**
   * Perf Test Hour Of Day
   * @default 0
   */
  perf_test_hour_of_day?: number;
  /**
   * Scan Gap
   * @default 1
   */
  scan_gap?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /**
   * Link Relay
   * @default false
   */
  link_relay?: boolean;
  /** Active Uplink */
  active_uplink?: string;
  /** Override Email */
  override_email?: string;
  /** Notification Muted Until */
  notification_muted_until?: string | null;
  /** Data Pool Id */
  data_pool_id?: string;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
  /** Speed Test Ip */
  speed_test_ip?: string;
  /** Source Ip */
  source_ip?: string;
  /** Rj45 Mac Address */
  rj45_mac_address?: string;
  /**
   * Provisioning Token
   * @default ""
   */
  provisioning_token?: string;
  /** Provisioning To Delete */
  provisioning_to_delete?: boolean;
  /**
   * Provisioning Expire Date
   * @default ""
   */
  provisioning_expire_date?: string;
  /**
   * Provisioning Last Provisioned At
   * @default ""
   */
  provisioning_last_provisioned_at?: string;
  /**
   * Provisioning First Created Date
   * @default ""
   */
  provisioning_first_created_date?: string;
  /**
   * Provisioning Recreated Date
   * @default ""
   */
  provisioning_recreated_date?: string;
  /** Data Pool Name */
  data_pool_name?: string;
  /** Cellular Static Ip */
  cellular_static_ip?: string;
}

/**
 * CpeCreate
 * Shared properties
 */
export interface CpeCreate {
  /** Cpe Name */
  cpe_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /**
   * Mode
   * @default "ROUTER"
   */
  mode?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /** Wan Cidr Addr */
  wan_cidr_addr?: string;
  /** Wan Default Gw Ip */
  wan_default_gw_ip?: string;
  /**
   * Wan Dns Ip
   * @default "8.8.8.8"
   */
  wan_dns_ip?: string;
  /**
   * Wan Snat
   * @default false
   */
  wan_snat?: boolean;
  /**
   * Wan Dhcp C
   * @default false
   */
  wan_dhcp_c?: boolean;
  /**
   * Wan Tx Mbps
   * @default 1000
   */
  wan_tx_mbps?: number;
  /**
   * Wan Rx Mbps
   * @default 1000
   */
  wan_rx_mbps?: number;
  /** Lan Cidr Addr */
  lan_cidr_addr?: string;
  /** Entity Name */
  entity_name?: string;
  /** Mgmt Cidr Addr */
  mgmt_cidr_addr?: string;
  /** Mgmt Default Gw Ip */
  mgmt_default_gw_ip?: string;
  /**
   * Mgmt Dns Ip
   * @default "8.8.8.8"
   */
  mgmt_dns_ip?: string;
  /**
   * Mgmt Dhcp C
   * @default false
   */
  mgmt_dhcp_c?: boolean;
  /** Wan Sfp */
  wan_sfp?: string;
  /** Lan Sfp */
  lan_sfp?: string;
  /**
   * Skip Default Gw Ping
   * @default false
   */
  skip_default_gw_ping?: boolean;
}

/**
 * CpeDetail
 * Shared properties
 */
export interface CpeDetail {
  /** Cpe Name */
  cpe_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /**
   * Mode
   * @default "ROUTER"
   */
  mode?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Cpe Id */
  cpe_id: string;
  /** Netflow Enabled */
  netflow_enabled?: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled?: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled?: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** App Visibility Enabled */
  app_visibility_enabled?: boolean;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Entity Id */
  entity_id?: string;
  /** Test Status */
  test_status?: string;
  /**
   * Test Started At
   * @format date-time
   */
  test_started_at?: string;
  /** Ping Email Notification */
  ping_email_notification?: string;
  /** Ping Webhook Notification */
  ping_webhook_notification?: string;
  /** Ip Monitor Target */
  ip_monitor_target?: string;
  /**
   * Iperf Server
   * @default false
   */
  iperf_server?: boolean;
  /**
   * Perf Test Scheduled
   * @default false
   */
  perf_test_scheduled?: boolean;
  /** Perf Test Peer Ip */
  perf_test_peer_ip?: string;
  /**
   * Perf Test Hour Of Day
   * @default 0
   */
  perf_test_hour_of_day?: number;
  /**
   * Scan Gap
   * @default 1
   */
  scan_gap?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /**
   * Link Relay
   * @default false
   */
  link_relay?: boolean;
  /** Active Uplink */
  active_uplink?: string;
  /** Override Email */
  override_email?: string;
  /** Notification Muted Until */
  notification_muted_until?: string | null;
  /** Data Pool Id */
  data_pool_id?: string;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
  /** Ports */
  ports?: object;
  /**
   * Additional Lan Ports
   * @default []
   */
  additional_lan_ports?: AdditionalLanPort[];
  /**
   * Uni Nid
   * @default false
   */
  uni_nid?: boolean;
  /** Rj45 Mac Address */
  rj45_mac_address?: string;
  /**
   * Provisioning Token
   * @default ""
   */
  provisioning_token?: string;
  /** Provisioning To Delete */
  provisioning_to_delete?: boolean;
  /**
   * Provisioning Expire Date
   * @default ""
   */
  provisioning_expire_date?: string;
  /**
   * Provisioning Last Provisioned At
   * @default ""
   */
  provisioning_last_provisioned_at?: string;
  /**
   * Provisioning First Created Date
   * @default ""
   */
  provisioning_first_created_date?: string;
  /**
   * Provisioning Recreated Date
   * @default ""
   */
  provisioning_recreated_date?: string;
}

/** CpeEditNetwork */
export interface CpeEditNetwork {
  /** Cpe Id */
  cpe_id: string;
  /** Mode */
  mode: string;
  /** Wan Cidr Addr */
  wan_cidr_addr?: string;
  /** Wan Default Gw Ip */
  wan_default_gw_ip?: string;
  /**
   * Wan Dns Ip
   * @default "8.8.8.8"
   */
  wan_dns_ip?: string;
  /**
   * Wan Snat
   * @default false
   */
  wan_snat?: boolean;
  /**
   * Wan Dhcp C
   * @default false
   */
  wan_dhcp_c?: boolean;
  /**
   * Wan Tx Mbps
   * @default 1000
   */
  wan_tx_mbps?: number;
  /**
   * Wan Rx Mbps
   * @default 1000
   */
  wan_rx_mbps?: number;
  /** Lan Cidr Addr */
  lan_cidr_addr?: string;
  /** Dhcp Server */
  dhcp_server?: boolean;
  /** Dhcp Ip S */
  dhcp_ip_s?: string;
  /** Dhcp Ip E */
  dhcp_ip_e?: string;
  /** Dns Ip */
  dns_ip?: string;
  /** Mgmt Cidr Addr */
  mgmt_cidr_addr?: string;
  /** Mgmt Default Gw Ip */
  mgmt_default_gw_ip?: string;
  /**
   * Mgmt Dns Ip
   * @default "8.8.8.8"
   */
  mgmt_dns_ip?: string;
  /**
   * Mgmt Dhcp C
   * @default false
   */
  mgmt_dhcp_c?: boolean;
  /** Wan Data Vlan Id */
  wan_data_vlan_id?: number;
  /** Wan Q In Q Vlan Id */
  wan_q_in_q_vlan_id?: number;
  /** Additional Lan Ports */
  additional_lan_ports?: string[];
  /** Activated Iccid */
  activated_iccid?: string;
}

/** CpeInfoUpdate */
export interface CpeInfoUpdate {
  /** Cpe Id */
  cpe_id: string;
  /** Cpe Name */
  cpe_name?: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Description */
  description?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /** Ping Email Notification */
  ping_email_notification?: string;
  /** Ping Webhook Notification */
  ping_webhook_notification?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
}

/**
 * CpeInterface
 * Compact interface descriptor returned by /get-cpe-interfaces.
 *
 * Just the user-facing port name and its role — no addressing, DHCP, or
 * operational state. Designed for UI pickers (e.g. the packet-capture
 * interface dropdown) that only need to render a list of selectable
 * interfaces and round-trip the role to /start-capture.
 */
export interface CpeInterface {
  /** Name */
  name: string;
  /** Role */
  role: string;
}

/** CpeProvisioned */
export interface CpeProvisioned {
  /** Cpe Id */
  cpe_id: string;
  /** Cpe Name */
  cpe_name: string;
  /** Site Address */
  site_address?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /** Provisioning Token */
  provisioning_token?: string;
  /** Token Expire Date */
  token_expire_date?: string;
  /** Tracking Number */
  tracking_number?: string;
  /** Last Provisioning Date */
  last_provisioning_date?: string;
}

/** CpeSecondaryWan */
export interface CpeSecondaryWan {
  /** Cpe Id */
  cpe_id: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /** Wan Cidr Addr */
  wan_cidr_addr?: string;
  /** Wan Default Gw Ip */
  wan_default_gw_ip?: string;
  /**
   * Wan Dns Ip
   * @default "8.8.8.8"
   */
  wan_dns_ip?: string;
  /**
   * Wan Dhcp C
   * @default false
   */
  wan_dhcp_c?: boolean;
  /**
   * Skip Default Gw Ping
   * @default false
   */
  skip_default_gw_ping?: boolean;
  /** Static Ip */
  static_ip?: boolean;
}

/**
 * DHCPRelay
 * DHCP Relay configuration received via API
 */
export interface DHCPRelay {
  /** Node Group Id */
  node_group_id: string;
  /** Enabled */
  enabled: boolean;
  /** Server Ip */
  server_ip?: string;
}

/**
 * DataPool
 * Shared properties
 */
export interface DataPool {
  /** Data Pool Name */
  data_pool_name: string;
  /** Description */
  description?: string;
  /** Entity Id */
  entity_id: string;
  /** An enumeration. */
  carrier: CellularCarrier;
  /** Data Allowance Mb */
  data_allowance_mb: number;
  /** Alert Enable */
  alert_enable: boolean;
  /**
   * Alert Threshold Percent
   * @default 90
   */
  alert_threshold_percent?: number;
  /** Throttle Enable */
  throttle_enable: boolean;
  /** Throttle Throughput Mbps */
  throttle_throughput_mbps?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Data Pool Id */
  data_pool_id: string;
  /** Account Id */
  account_id: string;
  /**
   * Monthly Data Usage
   * @default 0
   */
  monthly_data_usage?: number;
  /** Entity Name */
  entity_name?: string;
  /**
   * Usage Exceeded
   * @default false
   */
  usage_exceeded?: boolean;
  /**
   * Throttled
   * @default false
   */
  throttled?: boolean;
  /**
   * Num Cpes
   * @default 0
   */
  num_cpes?: number;
  /**
   * Monthly Data Usage Gb
   * @default 0
   */
  monthly_data_usage_gb?: number;
  /**
   * Reset Day
   * @default 1
   */
  reset_day?: number;
  /** Data Remaining Gb */
  data_remaining_gb?: number;
  /** Percent Left */
  percent_left?: number;
  /** Days Left In Cycle */
  days_left_in_cycle?: number;
}

/**
 * DataPoolCreate
 * Shared properties
 */
export interface DataPoolCreate {
  /** Data Pool Name */
  data_pool_name: string;
  /** Description */
  description?: string;
  /** Entity Id */
  entity_id?: string;
  /** An enumeration. */
  carrier: CellularCarrier;
  /** Data Allowance Mb */
  data_allowance_mb: number;
  /** Alert Enable */
  alert_enable: boolean;
  /**
   * Alert Threshold Percent
   * @default 90
   */
  alert_threshold_percent?: number;
  /** Throttle Enable */
  throttle_enable: boolean;
  /** Throttle Throughput Mbps */
  throttle_throughput_mbps?: number;
  /**
   * Reset Day
   * @default 1
   */
  reset_day?: number;
}

/** DataPoolEdit */
export interface DataPoolEdit {
  /** Data Pool Id */
  data_pool_id: string;
  /** Data Pool Name */
  data_pool_name?: string;
  /** Description */
  description?: string;
  /** Entity Id */
  entity_id?: string;
  /** An enumeration. */
  carrier?: CellularCarrier;
  /** Data Allowance Mb */
  data_allowance_mb?: number;
  /** Alert Enable */
  alert_enable?: boolean;
  /** Alert Threshold Percent */
  alert_threshold_percent?: number;
  /** Throttle Enable */
  throttle_enable?: boolean;
  /** Throttle Throughput Mbps */
  throttle_throughput_mbps?: number;
  /** Reset Day */
  reset_day?: number;
}

/** DeletedResponse */
export interface DeletedResponse {
  /** Deleted */
  deleted: boolean;
}

/** DiagnoseRequest */
export interface DiagnoseRequest {
  /** Message */
  message: string;
  /** Session Id */
  session_id?: string;
}

/** DisconnectConsoleAccess */
export interface DisconnectConsoleAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Hw Id Path */
  hw_id_path: string;
}

/** DisconnectNetworkRemoteAccess */
export interface DisconnectNetworkRemoteAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
  /**
   * Protocol
   * @default "ssh"
   */
  protocol?: string;
}

/** DisconnectRawSshAccess */
export interface DisconnectRawSshAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
}

/**
 * Document
 * Shared properties
 */
export interface Document {
  /** Filename */
  filename: string;
  /** Account Id */
  account_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Node Id */
  node_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Document Id */
  document_id: string;
  /**
   * Uploaded At Utc
   * @format date-time
   */
  uploaded_at_utc?: string;
  /** Size */
  size: number;
  /** Entity Name */
  entity_name?: string;
  /** Node Name */
  node_name?: string;
  /** Doc Type */
  doc_type?: string;
  /** S3 Download Url */
  s3_download_url?: string;
}

/** DocumentUpdate */
export interface DocumentUpdate {
  /** Document Id */
  document_id: string;
  /** Filename */
  filename?: string;
  /** Node Id */
  node_id?: string;
  /** Entity Id */
  entity_id?: string;
  /** Description */
  description?: string;
}

/** DocumentUploadUrl */
export interface DocumentUploadUrl {
  /** Document Id */
  document_id: string;
  /** S3 Url */
  s3_url: string;
}

/** DosStats */
export interface DosStats {
  /** Node Id */
  node_id: string;
  /** History */
  history: object[];
}

/** DosThreshold */
export interface DosThreshold {
  /** Alert Threshold */
  alert_threshold: number;
  /** Block Threshold */
  block_threshold: number;
  /** Max Threshold */
  max_threshold: number;
}

/**
 * Entity
 * Shared properties
 */
export interface Entity {
  /** Entity Name */
  entity_name: string;
  /** Description */
  description?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Entity Id */
  entity_id: string;
  /** Account Id */
  account_id: string;
  /** Parent Entity Id */
  parent_entity_id?: string;
  /** Logo Url */
  logo_url?: string;
  /** Email */
  email?: string;
  /** Parent Entity Name */
  parent_entity_name?: string;
}

/**
 * EntityCreate
 * Shared properties
 */
export interface EntityCreate {
  /** Entity Name */
  entity_name: string;
  /** Description */
  description?: string;
  /** Parent Entity Name */
  parent_entity_name?: string;
}

/** Ep */
export interface Ep {
  /** Ep Node Id */
  ep_node_id?: string;
  /** Ep Name */
  ep_name: string;
  /** Deployment */
  deployment?: string;
  /**
   * Region
   * @default ""
   */
  region?: string;
  /**
   * Consumer Principle
   * @default ""
   */
  consumer_principle?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Id */
  ep_id: string;
  /** Ip Addr */
  ip_addr?: string;
  /**
   * Endpoint Service
   * @default ""
   */
  endpoint_service?: string;
  /**
   * User Agent Dns Servers
   * @default ""
   */
  user_agent_dns_servers?: string;
  /**
   * User Agent Cidrs
   * @default ""
   */
  user_agent_cidrs?: string;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Primary Contact Id
   * @default ""
   */
  primary_contact_id?: string;
  /**
   * Secondary Contact Id
   * @default ""
   */
  secondary_contact_id?: string;
  /** App Service Id */
  app_service_id?: string;
  /** Fqdn */
  fqdn?: string;
  /**
   * Size
   * @default 0
   */
  size?: number;
  /**
   * Health
   * @default 0
   */
  health?: number;
  /**
   * Hosting Id
   * @default ""
   */
  hosting_id?: string;
  /**
   * Bgp Advertised Routes
   * @default ""
   */
  bgp_advertised_routes?: string;
}

/**
 * EpCreate
 * Properties to receive via API on creation
 */
export interface EpCreate {
  /** Ep Node Id */
  ep_node_id?: string;
  /** Ep Name */
  ep_name: string;
  /** Deployment */
  deployment?: string;
  /**
   * Region
   * @default ""
   */
  region?: string;
  /**
   * Consumer Principle
   * @default ""
   */
  consumer_principle?: string;
  /** App Service Id */
  app_service_id: string;
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Real Subnets */
  real_subnets?: string;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
}

/** EpDetail */
export interface EpDetail {
  /** Ep Node Id */
  ep_node_id?: string;
  /** Ep Name */
  ep_name: string;
  /** Deployment */
  deployment?: string;
  /**
   * Region
   * @default ""
   */
  region?: string;
  /**
   * Consumer Principle
   * @default ""
   */
  consumer_principle?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Id */
  ep_id: string;
  /** Ip Addr */
  ip_addr?: string;
  /**
   * Endpoint Service
   * @default ""
   */
  endpoint_service?: string;
  /**
   * User Agent Dns Servers
   * @default ""
   */
  user_agent_dns_servers?: string;
  /**
   * User Agent Cidrs
   * @default ""
   */
  user_agent_cidrs?: string;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Primary Contact Id
   * @default ""
   */
  primary_contact_id?: string;
  /**
   * Secondary Contact Id
   * @default ""
   */
  secondary_contact_id?: string;
  /** App Service Id */
  app_service_id?: string;
  /** Fqdn */
  fqdn?: string;
  /** Additional properties to return via API */
  ep_node?: EpNode;
  /** User Agents */
  user_agents: UserAgent[];
  /** Real Subnets */
  real_subnets?: string;
  /** Virtual Subnets */
  virtual_subnets?: string;
  /**
   * Address Translation Enabled
   * @default false
   */
  address_translation_enabled?: boolean;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Local Ip */
  bgp_local_ip?: string;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** Bgp Advertised Routes */
  bgp_advertised_routes?: string;
  /** Ep Primary Contact */
  ep_primary_contact?: string;
  /** Ep Secondary Contact */
  ep_secondary_contact?: string;
  /** App Service Primary Contact */
  app_service_primary_contact?: string;
  /** App Service Secondary Contact */
  app_service_secondary_contact?: string;
  /**
   * Proxying Enabled
   * @default false
   */
  proxying_enabled?: boolean;
}

/**
 * EpGroup
 * Additional properties to return via API
 */
export interface EpGroup {
  /** App Service Id */
  app_service_id: string;
  /** Ep Node Group Id */
  ep_node_group_id: string;
  /** Ep Group Name */
  ep_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Ep Group Id */
  ep_group_id: string;
  /** Fqdn */
  fqdn?: string;
  /** State */
  state?: string;
}

/**
 * EpNode
 * Additional properties to return via API
 */
export interface EpNode {
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Ep Node Name */
  ep_node_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Id */
  ep_node_id: string;
  /** Primary Ip */
  primary_ip?: string;
  /** Secondary Ips */
  secondary_ips?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
}

/**
 * EpNodeCreate
 * Properties to receive via API on creation
 */
export interface EpNodeCreate {
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Ep Node Name */
  ep_node_name?: string;
  /** New Ep Node Group */
  new_ep_node_group: boolean;
  /** Ep Node Group Name */
  ep_node_group_name?: string;
}

/**
 * EpNodeDetail
 * Additional properties stored in DB
 */
export interface EpNodeDetail {
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Ep Node Name */
  ep_node_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Id */
  ep_node_id: string;
  /** Primary Ip */
  primary_ip?: string;
  /** Secondary Ips */
  secondary_ips?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /** Endpoints */
  endpoints: Ep[];
  /**
   * Lan Interface Enabled
   * @default false
   */
  lan_interface_enabled?: boolean;
  /**
   * Lan Interface Ipaddress
   * @default ""
   */
  lan_interface_ipaddress?: string;
}

/**
 * EpNodeGroup
 * Additional properties to return via API
 */
export interface EpNodeGroup {
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Group Id */
  ep_node_group_id: string;
}

/**
 * EpNodeGroupCreate
 * Properties to receive via API on creation
 */
export interface EpNodeGroupCreate {
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /** Ep Node Name */
  ep_node_name?: string;
}

/**
 * EpNodeGroupDetail
 * Additional properties stored in DB
 */
export interface EpNodeGroupDetail {
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Group Id */
  ep_node_group_id: string;
  /**
   * Dhcp Relay Enabled
   * @default false
   */
  dhcp_relay_enabled?: boolean;
  /**
   * Dhcp Relay Server Ip
   * @default ""
   */
  dhcp_relay_server_ip?: string;
  /**
   * Vrrp Enabled
   * @default false
   */
  vrrp_enabled?: boolean;
  /**
   * Vrrp Virtual Ip
   * @default ""
   */
  vrrp_virtual_ip?: string;
}

/** EpProxying */
export interface EpProxying {
  /** Ep Id */
  ep_id: string;
  /** Enabled */
  enabled: boolean;
}

/**
 * EpUpdate
 * Properties to receive via API on update
 */
export interface EpUpdate {
  /** Ep Id */
  ep_id: string;
  /** User Agent Dns Servers */
  user_agent_dns_servers?: string;
  /** User Agent Cidrs */
  user_agent_cidrs?: string;
  /** Proxying */
  proxying?: boolean;
}

/** EpUserSession */
export interface EpUserSession {
  /** Src Address */
  src_address: string;
  /** Dst Address */
  dst_address: string;
  /** Established */
  established: boolean;
  /** Src Port */
  src_port?: number;
  /** Dst Port */
  dst_port?: number;
  /** Tx Packets */
  tx_packets?: number;
  /** Tx Bytes */
  tx_bytes?: number;
  /** Rx Packets */
  rx_packets?: number;
  /** Rx Bytes */
  rx_bytes?: number;
  /**
   * Protocol
   * @default ""
   */
  protocol?: string;
}

/** ExecScript */
export interface ExecScript {
  /** Node Id */
  node_id: string;
  /** Script */
  script: string;
}

/** GetAppNameByIP */
export interface GetAppNameByIP {
  /** Ip1 */
  ip1: string;
  /** Ip2 */
  ip2: string;
  /** Protocol */
  protocol: string;
  /** Ip1 Port */
  ip1_port: string;
  /** Ip2 Port */
  ip2_port: string;
  /** Force Match Port */
  force_match_port: boolean;
}

/** GetCaptureStatusResp */
export interface GetCaptureStatusResp {
  /** Result */
  result: string;
  /** Capturing */
  capturing?: boolean;
  /** File Size */
  file_size?: number;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HealthResponse */
export interface HealthResponse {
  /** Status */
  status: string;
  /** Model */
  model: string;
  /** Provider */
  provider: string;
  /** Active Users */
  active_users: number;
  /** Total Sessions */
  total_sessions: number;
}

/** HistoryResponse */
export interface HistoryResponse {
  /** Session Id */
  session_id: string;
  /** History */
  history: (
    | UserMessage
    | AssistantMessage
    | ToolCallMessage
    | ToolResultMessage
    | (UserMessage & AssistantMessage & ToolCallMessage & ToolResultMessage)
  )[];
}

/** Hosting */
export interface Hosting {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** App Service Id */
  app_service_id?: string;
  /** Hosting Id */
  hosting_id?: string;
  /** Hosting Type */
  hosting_type?: string;
  /** Region */
  region?: string;
  /** Service Provider */
  service_provider?: string;
  /** Cloud Endpoint Service Name */
  cloud_endpoint_service_name?: string;
  /** Service Node Group Name */
  service_node_group_name?: string;
  /** Fqdn */
  fqdn?: string;
  /** Priority Id */
  priority_id?: number;
  /** Size */
  size?: number;
  /** Health */
  health?: number;
}

/**
 * HostingType
 * An enumeration.
 */
export enum HostingType {
  Cloud = 'cloud',
  Onprem = 'onprem',
}

/** IPAppName */
export interface IPAppName {
  /** App Name */
  app_name: string;
  /** Ip Cidr */
  ip_cidr: string;
  /** Tcp Ports */
  tcp_ports: string;
  /** Udp Ports */
  udp_ports: string;
  /** Domain */
  domain: string;
}

/**
 * IamRole
 * An enumeration.
 */
export enum IamRole {
  Readonly = 'readonly',
  Admin = 'admin',
}

/** IamUser */
export interface IamUser {
  /** Username */
  username: string;
  /** An enumeration. */
  role: IamRole;
  /** Name */
  name?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Iam User Id */
  iam_user_id: string;
  /** Account Id */
  account_id: string;
  /** Mfa Enabled */
  mfa_enabled?: boolean;
  /** Mfa Type */
  mfa_type?: string;
  /**
   * Last Login Time
   * @format date-time
   */
  last_login_time?: string;
  /** Entity Id */
  entity_id?: string;
  /** Logo */
  logo?: string;
  /** Entity Name */
  entity_name?: string;
  /**
   * Inactivity Locked
   * @default false
   */
  inactivity_locked?: boolean;
}

/** IamUserCreate */
export interface IamUserCreate {
  /** Username */
  username: string;
  /** An enumeration. */
  role: IamRole;
  /** Name */
  name?: string;
  /** Entity Name */
  entity_name?: string;
}

/** IamUserUpdate */
export interface IamUserUpdate {
  /** Name */
  name?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /** Password */
  password?: string;
}

/** IperfServer */
export interface IperfServer {
  /** Cpe Id */
  cpe_id: string;
  /** Enable */
  enable: boolean;
}

/**
 * LANInterface
 * LAN Interface configuration received via API
 */
export interface LANInterface {
  /** Node Id */
  node_id: string;
  /** Enabled */
  enabled: boolean;
  /** Primary Ipv4 Address */
  primary_ipv4_address?: string;
  /** Secondary Ipv4 Addresses */
  secondary_ipv4_addresses?: string;
}

/**
 * Metro
 * Shared properties
 */
export interface Metro {
  /** Metro Name */
  metro_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Metro Id */
  metro_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Netflow Enabled */
  netflow_enabled: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** Oam Loopback Enabled */
  oam_loopback_enabled?: boolean;
  /** Oam Ccp Enabled */
  oam_ccp_enabled?: boolean;
  /** Oam Ccm Interval */
  oam_ccm_interval?: number;
  /** Oam Md Name */
  oam_md_name?: string;
  /** Oam Md Level */
  oam_md_level?: number;
  /** Oam Md Association */
  oam_md_association?: string;
  /** Oam Mep Id */
  oam_mep_id?: number;
  /** Oam Vlan Id */
  oam_vlan_id?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
}

/**
 * MetroCreate
 * Shared properties
 */
export interface MetroCreate {
  /** Metro Name */
  metro_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /** Wan Data Vlan Id */
  wan_data_vlan_id?: number;
  /** Wan Q In Q Vlan Id */
  wan_q_in_q_vlan_id?: number;
  /** Lan Data Vlan Id */
  lan_data_vlan_id?: number;
  /** Lan Q In Q Vlan Id */
  lan_q_in_q_vlan_id?: number;
  /**
   * Wan Mgmt Vlan Id
   * @default 100
   */
  wan_mgmt_vlan_id?: number;
  /** Entity Name */
  entity_name?: string;
  /** Wan Sfp */
  wan_sfp?: string;
  /** Lan Sfp */
  lan_sfp?: string;
}

/**
 * MetroDetail
 * Shared properties
 */
export interface MetroDetail {
  /** Metro Name */
  metro_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Metro Id */
  metro_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Netflow Enabled */
  netflow_enabled: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** Oam Loopback Enabled */
  oam_loopback_enabled?: boolean;
  /** Oam Ccp Enabled */
  oam_ccp_enabled?: boolean;
  /** Oam Ccm Interval */
  oam_ccm_interval?: number;
  /** Oam Md Name */
  oam_md_name?: string;
  /** Oam Md Level */
  oam_md_level?: number;
  /** Oam Md Association */
  oam_md_association?: string;
  /** Oam Mep Id */
  oam_mep_id?: number;
  /** Oam Vlan Id */
  oam_vlan_id?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
  /** Ports */
  ports?: object;
}

/** MetroInfoUpdate */
export interface MetroInfoUpdate {
  /** Metro Id */
  metro_id: string;
  /** Metro Name */
  metro_name?: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Description */
  description?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Wan Data Vlan Id */
  wan_data_vlan_id?: number;
  /** Wan Q In Q Vlan Id */
  wan_q_in_q_vlan_id?: number;
  /** Lan Data Vlan Id */
  lan_data_vlan_id?: number;
  /** Lan Q In Q Vlan Id */
  lan_q_in_q_vlan_id?: number;
  /** Wan Mgmt Vlan Id */
  wan_mgmt_vlan_id?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
}

/** MetroLoopbackTest */
export interface MetroLoopbackTest {
  /** Metro Id */
  metro_id: string;
  /** Lpbk Src Mac Addr */
  lpbk_src_mac_addr: string;
}

/** MetroOamEdit */
export interface MetroOamEdit {
  /** Metro Id */
  metro_id: string;
  /** Loopback Enabled */
  loopback_enabled: boolean;
  /** Ccp Enabled */
  ccp_enabled: boolean;
  /** Ccm Interval */
  ccm_interval?: number;
  /** Md Name */
  md_name?: string;
  /** Md Level */
  md_level?: number;
  /** Md Association */
  md_association?: string;
  /** Mep Id */
  mep_id?: number;
  /** Vlan Id */
  vlan_id?: number;
}

/** MetroPerformanceTest */
export interface MetroPerformanceTest {
  /** Metro Id */
  metro_id: string;
  /** Peer Ip */
  peer_ip?: string;
  /** Peer Mac */
  peer_mac?: string;
  /** Vlan Id */
  vlan_id?: number;
}

/**
 * MfaType
 * An enumeration.
 */
export enum MfaType {
  Email = 'email',
}

/** NetworkDeviceOnDiagPort */
export interface NetworkDeviceOnDiagPort {
  /** Node Id */
  node_id: string;
  /** Ip Addr */
  ip_addr: string;
  /** Mac Addr */
  mac_addr: string;
  /** Vendor Name */
  vendor_name?: string;
  /** Device Name */
  device_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Network Device Id */
  network_device_id: string;
  /** Reachable */
  reachable?: boolean;
  /**
   * Reachable At
   * @format date-time
   */
  reachable_at?: string;
}

/** NetworkDeviceOnDiagPortAdd */
export interface NetworkDeviceOnDiagPortAdd {
  /** Node Id */
  node_id: string;
  /** Device Name */
  device_name: string;
  /** Ip Addr */
  ip_addr: string;
  /** Mac Addr */
  mac_addr?: string;
  /** Vendor Name */
  vendor_name?: string;
}

/** NetworkDeviceOnDiagPortEditName */
export interface NetworkDeviceOnDiagPortEditName {
  /** Node Id */
  node_id: string;
  /** Mac Addr */
  mac_addr: string;
  /** Device Name */
  device_name: string;
}

/** NetworkDeviceOnDiagPortWithSessions */
export interface NetworkDeviceOnDiagPortWithSessions {
  /** Node Id */
  node_id: string;
  /** Ip Addr */
  ip_addr: string;
  /** Mac Addr */
  mac_addr: string;
  /** Vendor Name */
  vendor_name?: string;
  /** Device Name */
  device_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Network Device Id */
  network_device_id: string;
  /** Reachable */
  reachable?: boolean;
  /**
   * Reachable At
   * @format date-time
   */
  reachable_at?: string;
  /**
   * Sessions
   * @default []
   */
  sessions?: object[];
}

/** NodeConnStatus */
export interface NodeConnStatus {
  /** Node Id */
  node_id: string;
  /** Percent */
  percent: string;
  /** Uptime */
  uptime: number;
  /** Downtime */
  downtime: number;
  /** Total */
  total: number;
  /** History */
  history: object[];
  /** Conn Status Start At */
  conn_status_start_at?: string;
}

/** PacketCapture */
export interface PacketCapture {
  /** Node Id */
  node_id: string;
  /** Interface */
  interface?: string;
  /**
   * Tcpdump Args
   * @maxLength 1000
   */
  tcpdump_args?: string;
  /**
   * Max Size Mb
   * @min 1
   * @max 1024
   * @default 1024
   */
  max_size_mb?: number;
  /**
   * Max Duration S
   * @min 1
   * @max 86400
   * @default 86400
   */
  max_duration_s?: number;
}

/**
 * PaymentProvider
 * An enumeration.
 */
export enum PaymentProvider {
  Aws = 'aws',
  Stripe = 'stripe',
}

/**
 * Pdu
 * Shared properties
 */
export interface Pdu {
  /** Node Id */
  node_id: string;
  /** Pdu Name */
  pdu_name: string;
  /** Vendor Name */
  vendor_name: string;
  /** Ip Addr */
  ip_addr: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Pdu Id */
  pdu_id: string;
  /** Model Name */
  model_name?: string;
  /** Serial Number */
  serial_number?: string;
  /** Bank Count */
  bank_count?: number;
  /** Outlet Count */
  outlet_count?: number;
  /** Reachable */
  reachable?: boolean;
  /**
   * Reachable At
   * @format date-time
   */
  reachable_at?: string;
  /** Outlets */
  outlets?: any[];
  /** Mac Addr */
  mac_addr?: string;
}

/**
 * PduCreate
 * Shared properties
 */
export interface PduCreate {
  /** Node Id */
  node_id: string;
  /** Pdu Name */
  pdu_name: string;
  /** Vendor Name */
  vendor_name: string;
  /** Ip Addr */
  ip_addr: string;
}

/** PduEditInfo */
export interface PduEditInfo {
  /** Pdu Id */
  pdu_id: string;
  /** Ip Addr */
  ip_addr?: string;
  /** Pdu Name */
  pdu_name?: string;
  /** Description */
  description?: string;
}

/**
 * PduOutletState
 * An enumeration.
 */
export enum PduOutletState {
  On = 'on',
  Off = 'off',
}

/** PerfTestSchedule */
export interface PerfTestSchedule {
  /** Cpe Id */
  cpe_id: string;
  /** Enable */
  enable: boolean;
  /** Peer Region */
  peer_region?: string;
  /** Hour Of Day */
  hour_of_day?: number;
}

/** QueryPcapResp */
export interface QueryPcapResp {
  /** Document Id */
  document_id: string;
  /** Result */
  result: string;
}

/** S3UploadUrl */
export interface S3UploadUrl {
  /** S3 Url */
  s3_url: string;
  /** Pcap File Key */
  pcap_file_key: string;
  /** Pcap File Name */
  pcap_file_name: string;
}

/** ServiceNode */
export interface ServiceNode {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Name */
  service_node_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Service Node Id */
  service_node_id: string;
  /** Public Ip */
  public_ip?: string;
  /** Private Ip */
  private_ip?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Udp Tunnel Status */
  udp_tunnel_status?: string;
  /**
   * Udp Tunnel Status Change At
   * @format date-time
   */
  udp_tunnel_status_change_at?: string;
  /** Udp Tunnel Peer Ip */
  udp_tunnel_peer_ip?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
}

/** ServiceNodeCreate */
export interface ServiceNodeCreate {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Name */
  service_node_name: string;
  /** New Service Node Group */
  new_service_node_group: boolean;
  /** Service Node Group Name */
  service_node_group_name?: string;
}

/** ServiceNodeDetail */
export interface ServiceNodeDetail {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Name */
  service_node_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Service Node Id */
  service_node_id: string;
  /** Public Ip */
  public_ip?: string;
  /** Private Ip */
  private_ip?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Udp Tunnel Status */
  udp_tunnel_status?: string;
  /**
   * Udp Tunnel Status Change At
   * @format date-time
   */
  udp_tunnel_status_change_at?: string;
  /** Udp Tunnel Peer Ip */
  udp_tunnel_peer_ip?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** App Services */
  app_services: AppService[];
  /** Endpoints */
  endpoints: Ep[];
}

/** ServiceNodeGroup */
export interface ServiceNodeGroup {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Service Node Group Name */
  service_node_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Service Node Group Id */
  service_node_group_id: string;
  /** External Certificate */
  external_certificate?: boolean;
}

/** ServiceNodeGroupCreate */
export interface ServiceNodeGroupCreate {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Service Node Group Name */
  service_node_group_name: string;
}

/** SessionInfo */
export interface SessionInfo {
  /** Session Id */
  session_id: string;
  /** Created At */
  created_at: string;
  /** Last Active */
  last_active: string;
  /** Turn Count */
  turn_count: number;
}

/** SessionsResponse */
export interface SessionsResponse {
  /** Sessions */
  sessions: SessionInfo[];
}

/** SetNodeFormFactor */
export interface SetNodeFormFactor {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Node Id */
  node_id: string;
}

/** SkillInfo */
export interface SkillInfo {
  /** Name */
  name: string;
  /** Description */
  description: string;
}

/** SkillsResponse */
export interface SkillsResponse {
  /** Skills */
  skills: SkillInfo[];
}

/** SpeedtestCliStartResponse */
export interface SpeedtestCliStartResponse {
  /** Status */
  status: string;
  /** Sse Id */
  sse_id: string;
}

/** SpeedtestCliTestResult */
export interface SpeedtestCliTestResult {
  /** Download Speed Mbps */
  download_speed_mbps: number;
  /** Upload Speed Mbps */
  upload_speed_mbps: number;
  /** Ping Latency Ms */
  ping_latency_ms: number;
  /** Ping Jitter Ms */
  ping_jitter_ms: number;
  /** Result Url */
  result_url: string;
}

/** StartCaptureResp */
export interface StartCaptureResp {
  /** Result */
  result: string;
}

/** StopCaptureResp */
export interface StopCaptureResp {
  /** Result */
  result: string;
}

/** SwitchAccountRequest */
export interface SwitchAccountRequest {
  /** Account Id */
  account_id: string;
}

/**
 * Ticket
 * Shared properties
 */
export interface Ticket {
  /** Title */
  title: string;
  /** Description */
  description?: string;
  /** An enumeration. */
  priority: TicketPriority;
  /** Device Id */
  device_id?: string;
  /** An enumeration. */
  category: TicketCategory;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Ticket Id */
  ticket_id: string;
  /** State */
  state: string;
  /** Created By */
  created_by?: string;
  /** Account Id */
  account_id?: string;
  /** Entity Id */
  entity_id?: string;
}

/**
 * TicketCategory
 * An enumeration.
 */
export enum TicketCategory {
  ReportAProblem = 'Report a problem',
  RequestAFeature = 'Request a feature',
  Other = 'Other',
}

/**
 * TicketCreate
 * Shared properties
 */
export interface TicketCreate {
  /** Title */
  title: string;
  /** Description */
  description?: string;
  /** An enumeration. */
  priority: TicketPriority;
  /** Device Id */
  device_id?: string;
  /** An enumeration. */
  category: TicketCategory;
}

/**
 * TicketDetail
 * Shared properties
 */
export interface TicketDetail {
  /** Title */
  title: string;
  /** Description */
  description?: string;
  /** An enumeration. */
  priority: TicketPriority;
  /** Device Id */
  device_id?: string;
  /** An enumeration. */
  category: TicketCategory;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Ticket Id */
  ticket_id: string;
  /** State */
  state: string;
  /** Created By */
  created_by?: string;
  /** Account Id */
  account_id?: string;
  /** Entity Id */
  entity_id?: string;
  /** Correspondence */
  correspondence: Correspondence[];
}

/**
 * TicketPriority
 * An enumeration.
 */
export enum TicketPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

/** ToolCallMessage */
export interface ToolCallMessage {
  /** Role */
  role: 'tool_call';
  /** Name */
  name: string;
  /** Input */
  input: object;
}

/** ToolInfo */
export interface ToolInfo {
  /** Name */
  name: string;
  /** Description */
  description: string;
}

/** ToolResultMessage */
export interface ToolResultMessage {
  /** Role */
  role: 'tool_result';
  /** Content */
  content: string;
}

/** ToolsResponse */
export interface ToolsResponse {
  /** Tools */
  tools: ToolInfo[];
}

/** UsbConsoleSettings */
export interface UsbConsoleSettings {
  /** Cpe Id */
  cpe_id: string;
  /** Hw Id Path */
  hw_id_path: string;
  /**
   * Label
   * @default "Change me"
   */
  label?: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /**
   * Baud Rate
   * @default 9600
   */
  baud_rate?: number;
  /**
   * Parity
   * @default "none"
   */
  parity?: string;
  /**
   * Bits
   * @default 8
   */
  bits?: number;
  /**
   * Stop Bits
   * @default 1
   */
  stop_bits?: number;
}

/** UsbConsoleSettingsResponse */
export interface UsbConsoleSettingsResponse {
  /** Label */
  label: string;
  /** Description */
  description: string;
  /** Baud Rate */
  baud_rate: number;
  /** Parity */
  parity: string;
  /** Bits */
  bits: number;
  /** Stop Bits */
  stop_bits: number;
}

/** UserAgent */
export interface UserAgent {
  /** Name */
  name?: string;
  /** Email */
  email: string;
  /** Description */
  description?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /**
   * Last Connect Time
   * @format date-time
   */
  last_connect_time?: string;
  /**
   * Last Disconnect Time
   * @format date-time
   */
  last_disconnect_time?: string;
  /** Connected */
  connected?: boolean;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /**
   * Last Auth Time
   * @format date-time
   */
  last_auth_time?: string;
  /** Last Auth Status */
  last_auth_status?: boolean;
  /** User Agent Id */
  user_agent_id: string;
  /** App Service Id */
  app_service_id?: string;
}

/** UserAgentCreate */
export interface UserAgentCreate {
  /** Name */
  name?: string;
  /** Email */
  email: string;
  /** Description */
  description?: string;
  /** Ep Id */
  ep_id?: string;
}

/** UserMessage */
export interface UserMessage {
  /** Role */
  role: 'user';
  /** Text */
  text: string;
}

/**
 * VRRPConfig
 * VRRP configuration received via API
 */
export interface VRRPConfig {
  /** Node Group Id */
  node_group_id: string;
  /** Enabled */
  enabled: boolean;
  /** Virtual Ip */
  virtual_ip?: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number | (string & number))[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}
